import React from "react";
import PropTypes from "prop-types";
import { PropertyBadgesContainerWrapper } from "./PropertyBadgesContainer.styles";
import PropertyStatusBadge from "../PropertyStatusBadge/PropertyStatusBadge";
import { getPropertyStatusBadge } from "../../utils/propertyStatusUtils";
import { maximumYellow400, scarpaGray800, scarpaGray900, white } from "StylesConstants";
import { isDefaultCountry } from "../../utils/utils";

const isFranchiseValue = (value) => value === true || Number(value) === 1;

const DocsCheckIcon = () => (
  <svg width="12" height="12" viewBox="0 0 14 14" aria-hidden="true">
    <rect width="14" height="14" rx="2" fill="#22C55E" />
    <path
      d="M3.5 7.2L6 9.7L10.5 4.5"
      stroke="#FFFFFF"
      strokeWidth="1.6"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PropertyBadgesContainer = ({
  inventoryTypeId = null,
  hasThreeChecks = null,
  isFranchise = false,
}) => {
  const badgeConfig = inventoryTypeId ? getPropertyStatusBadge(inventoryTypeId) : null;
  const isMx = !isDefaultCountry();
  const isCaptured = inventoryTypeId === 2;
  const showFranchise = isMx && isCaptured && isFranchiseValue(isFranchise);
  const showDocs = isMx && isCaptured && !showFranchise && Number(hasThreeChecks) === 1;

  const chips = [
    showDocs && {
      key: "docs",
      label: "Docs",
      backgroundColor: maximumYellow400,
      textColor: scarpaGray800,
      endIcon: <DocsCheckIcon />,
    },
    showFranchise && {
      key: "franchise",
      label: "Franquicia",
      backgroundColor: scarpaGray900,
      textColor: white,
    },
    badgeConfig && {
      key: "status",
      label: badgeConfig.label,
      backgroundColor: badgeConfig.backgroundColor,
      textColor: badgeConfig.textColor,
      toolTipMessage: badgeConfig.toolTipMessage,
    },
  ].filter(Boolean);

  const hasMultipleBadges = chips.length > 1;

  return (
    <PropertyBadgesContainerWrapper>
      {chips.map((chip, index) => (
        <PropertyStatusBadge
          key={chip.key}
          label={chip.label}
          backgroundColor={chip.backgroundColor}
          textColor={chip.textColor}
          toolTipMessage={chip.toolTipMessage}
          endIcon={chip.endIcon}
          fontSize="14px"
          $isFirst={index === 0}
          $isLast={index === chips.length - 1}
          $hasMultipleBadges={hasMultipleBadges}
        />
      ))}
    </PropertyBadgesContainerWrapper>
  );
};

PropertyBadgesContainer.propTypes = {
  inventoryTypeId: PropTypes.number,
  hasThreeChecks: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isFranchise: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
};

export default PropertyBadgesContainer;
